import * as React from 'react';
import * as s from './LinkMore.scss';
import {getStarted, Links} from '../../utils/ctaLinks';
import ArrowLink, {ArrowLinkProps} from '../ArrowLink';
import experiments from '../../utils/experiments';

export interface LinkMoreProps extends ArrowLinkProps {
  links?: Links;
}

export const LinkMore: React.SFC<LinkMoreProps> = ({children, className, links, ...otherProps}) => {
  const isAnonymous = String(experiments.get('specs.marketing.EnableAnonMainFunnelIntroLinks')) === 'true';
  const ctaLinks = links || getStarted(isAnonymous);
  const classes = [];
  if (className) {
    classes.push(className);
  }
  return (
    <>
      <ArrowLink {...otherProps} data-hook={[otherProps['data-hook'], 'link-desktop'].join(' ')} className={classes.concat(s.desktop).join(' ')} key="desktop" href={ctaLinks && ctaLinks.desktop}>{children}</ArrowLink>
      <ArrowLink {...otherProps} data-hook={[otherProps['data-hook'], 'link-mobile'].join(' ')} className={classes.concat(s.mobile).join(' ')} key="mobile" href={ctaLinks && ctaLinks.mobile}>{children}</ArrowLink>
    </>
  );
};

LinkMore.defaultProps = {
  theme: 'normal'
};

export default LinkMore;
